
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';


export const nestApiCreateConsumer = FBF_CloudCallable<
  any,
  any
>('api/consumers|POST');
